/* Modulo: Category Cards — scroll-snap rail controller.
   The rail swipes/scrolls natively with no JS; this only wires the arrows,
   their disabled state, the counter, and the mobile progress thumb.
   Vanilla, RTL- and reduced-motion aware, self-healing across theme-editor
   re-renders. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  // Held live, not cached to a boolean: the CSS side responds to an OS
  // reduced-motion toggle mid-session via @media, so the JS must too or the
  // two halves disagree.
  var REDUCE_MQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduce() { return !!(REDUCE_MQ && REDUCE_MQ.matches); }

  function pad2(n) { return n < 10 ? '0' + n : String(n); }

  function init(root) {
    if (!root || root.dataset.moduloCcdReady === '1') return;
    root.dataset.moduloCcdReady = '1';

    var rail = root.querySelector('[data-modulo-ccd-rail]');
    if (!rail) return;

    var prev = root.querySelector('[data-modulo-ccd-prev]');
    var next = root.querySelector('[data-modulo-ccd-next]');
    var index = root.querySelector('[data-modulo-ccd-index]');
    var track = root.querySelector('[data-modulo-ccd-track]');
    var thumb = root.querySelector('[data-modulo-ccd-thumb]');
    var rtl = window.getComputedStyle(rail).direction === 'rtl';
    var total = rail.children.length;

    // Card step (width + gap) is constant between resizes — measuring it every
    // scroll frame forces a layout on the one device class that actually swipes.
    var stepCache = 0;
    function step() {
      if (stepCache > 0) return stepCache;
      var card = rail.querySelector('.modulo-ccd__card');
      if (!card) return rail.clientWidth * 0.8;
      var cs = window.getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var w = card.getBoundingClientRect().width;
      if (w <= 0) return rail.clientWidth * 0.8;
      stepCache = w + gap;
      return stepCache;
    }
    function gapPx() {
      var cs = window.getComputedStyle(rail);
      return parseFloat(cs.columnGap || cs.gap) || 0;
    }

    function sync() {
      if (!root.isConnected) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var pos = Math.abs(rail.scrollLeft);

      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max - 2;

      // Report the last FULLY-VISIBLE card, not the leading one. On a peek rail
      // max/step is identically (total - cards_per_view), so a leading-card
      // counter can never reach `total` — it would read "04 / 06" with cards 5
      // and 6 on screen. Adding the viewport makes the end land exactly on total.
      if (index) {
        var s = step();
        var n = s > 0 ? Math.round((pos + rail.clientWidth + gapPx()) / s) : 1;
        if (n > total) n = total;
        if (n < 1) n = 1;
        index.textContent = pad2(n);
      }

      // Travel measured in px from the real boxes, so the thumb's CSS width and
      // the JS can't drift apart.
      if (thumb && track) {
        var room = track.clientWidth - thumb.offsetWidth;
        var pct = max > 0 ? pos / max : 0;
        thumb.style.translate = (pct * room * (rtl ? -1 : 1)) + 'px';
      }
    }
    root._ccdSync = function () { stepCache = 0; sync(); };

    function page(dir) {
      var s = step();
      var perClick = Math.max(1, Math.floor(rail.clientWidth / s));
      var delta = dir * s * perClick * (rtl ? -1 : 1);
      rail.scrollBy({ left: delta, behavior: reduce() ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    var raf = null;
    rail.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    sync();
  }

  // ONE shared resize listener that re-queries live roots. A per-instance
  // listener would accumulate across theme-editor re-renders (the editor swaps
  // in a fresh node, so the dataset guard can't dedupe) and each dead closure
  // would pin its whole detached card subtree.
  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      var els = document.querySelectorAll('[data-modulo-ccd]');
      for (var i = 0; i < els.length; i++) {
        if (typeof els[i]._ccdSync === 'function') els[i]._ccdSync();
      }
    }, 100);
  });

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-ccd]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Shopify theme editor: (re)init when a section is added/redrawn.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
